/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ThumbsDownList } from './thumbsDownList';

export type GenericApiResponseThumbsDownListData = ThumbsDownList | null;
